import React from "react";
import CheckIconImg from "@/assets/images/blue-check-icon.svg";
function CheckIcon() {
  return <img src={CheckIconImg} alt="check icon" />;
}

export default CheckIcon;
